export default (function (LocaleService) {
    return {
        'optionalVisibility': function optionalVisibility(cond, target) {
            return cond ? target : 'OPTIONAL';
        },
        'belongsToFilter': function belongsToFilter(value, filterName) {
            return value && value.typelist.getFilter(filterName).allows(value);
        },
        'hasCategory': function hasCategory(value, parent) {
            if (!parent) {
                return false;
            }

            return value.belongsToCategory(parent);
        },
        'getContextValue': function getContextValue(context, prop) {
            return context(prop);
        },
        matchesPattern: function matchesPattern(pattern, value) {
            return !pattern || !value || new RegExp('^' + pattern + '$').test(value);
        },
        'typekeyIn': function typekeyIn(tk, values) {
            return values.indexOf(tk.code) >= 0;
        },
        'range': function range(l, r, m) {
            return l <= m && m <= r;
        },
        'strLength': function strLength(s) {
            return s ? s.length : 0;
        },
        'getFromMap': function getFromMap(m, k) {
            return m[k];
        },
        'compareDate': function compareDate(d1, d2) {
            return new Date(d1).getTime() - new Date(d2).getTime();
        },
        'isEmpty': function isEmpty(s1) {
            return !s1 || s1.length === 0;
        },
        'isCurrency': function isCurrency(obj) {
            if (!angular.isDefined(obj) || obj === null || obj === '') {
                return false;
            }

            if (typeof obj === 'number') {
                obj = obj.toString();
            }

            if (typeof obj !== 'string') {
                return false;
            }

            if (!obj.match(/^\d*(.\d*)?$/)) {
                return false;
            }

            var currencyInfo = LocaleService.getLocaleInfo().currency;
            return obj.indexOf('.') === -1 || obj.indexOf('.') >= obj.length - (currencyInfo.fractionSize + 1);
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-viewmodel-js/aspects/_ValidationFunctions.js
// module id = 945
// module chunks = 0